var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('suc-select-component',{attrs:{"form":_vm.form,"name":_vm.name,"title":_vm.title,"options":_vm.options,"reduce":function (option) { return option.value; }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }